import "../css/header.scss";
import React, { useContext, useEffect, useRef, useState } from "react";
import { Link, useLocation } from "react-router-dom";
import { CartContext } from "./CartContext";
import { STORE_CONFIG } from "../config/storeConfig";

const moreLinks = [
  ["Privacy", "/policies/privacy"],
  ["Terms", "/policies/terms"],
  ["Shipping", "/policies/shipping"],
  ["Returns", "/policies/returns"],
  ["FAQ", "/policies/faq"],
  ["Cookie", "/policies/cookies"],
];

function BrandLockup() {
  return (
    <span className="brand-lockup" aria-label={STORE_CONFIG.brand}>
      <svg className="brand-mark" viewBox="0 0 52 52" aria-hidden="true">
        <circle cx="26" cy="26" r="21" fill="none" stroke="currentColor" strokeWidth="2" />
        <path d="M15 31c8-1 15-7 20-17 3 12-1 22-12 25-5 1-8-2-8-8Z" fill="currentColor" />
        <path d="M14 16c9 1 17 6 23 15" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" />
      </svg>
      <span className="brand-word"><span>{STORE_CONFIG.brand.slice(0, 4)}</span><span>{STORE_CONFIG.brand.slice(4)}</span></span>
    </span>
  );
}

function Header() {
  const { cartItems } = useContext(CartContext);
  const [moreOpen, setMoreOpen] = useState(false);
  const menuRef = useRef(null);
  const location = useLocation();
  const cartCount = cartItems.reduce((total, item) => total + item.quantity, 0);

  useEffect(() => setMoreOpen(false), [location.pathname]);
  useEffect(() => {
    const close = (event) => {
      if (menuRef.current && !menuRef.current.contains(event.target)) setMoreOpen(false);
    };
    const onKey = (event) => event.key === "Escape" && setMoreOpen(false);
    document.addEventListener("pointerdown", close);
    document.addEventListener("keydown", onKey);
    return () => {
      document.removeEventListener("pointerdown", close);
      document.removeEventListener("keydown", onKey);
    };
  }, []);

  const toTop = () => window.scrollTo({ top: 0, behavior: "smooth" });

  return (
    <header className="site-header">
      <div className="top-banner">Bags for considered everyday movement · {STORE_CONFIG.operatingRegion}</div>
      <div className="header-content">
        <div className="header-left" aria-hidden="true" />
        <div className="header-center">
          <Link to="/" onClick={toTop} className="logo-container"><BrandLockup /><span className="subtitle">bags · materials · movement</span></Link>
          <nav className="main-nav" aria-label="Primary navigation">
            <ul>
              <li><Link to="/shop" onClick={toTop}>SHOP</Link></li>
              <li><Link to="/about" onClick={toTop}>OUR STORY</Link></li>
              <li><Link to="/contact" onClick={toTop}>CONTACT</Link></li>
              <li className="more-menu" ref={menuRef}>
                <button type="button" aria-expanded={moreOpen} aria-controls="more-navigation" onClick={() => setMoreOpen((open) => !open)}>
                  MORE <span aria-hidden="true">{moreOpen ? "−" : "+"}</span>
                </button>
                <ul id="more-navigation" className={moreOpen ? "more-dropdown is-open" : "more-dropdown"}>
                  {moreLinks.map(([label, to]) => <li key={to}><Link to={to} onClick={toTop}>{label}</Link></li>)}
                </ul>
              </li>
            </ul>
          </nav>
        </div>
        <div className="header-right header-actions">
          <Link to="/cartpage" className="action-btn cart-btn" aria-label={`Cart with ${cartCount} items`} onClick={toTop}>
            <svg aria-hidden="true" className="icon icon-cart" viewBox="0 0 37 40" width="25" height="25"><path d="M36.5 34.8 33.3 8h-5.9C26.7 3.9 23 .8 18.5.8S10.3 3.9 9.6 8H3.7L.5 34.8c-.2 1.5.4 2.4.9 3 .5.5 1.4 1.2 3.1 1.2h28c1.3 0 2.4-.4 3.1-1.3.7-.7 1-1.8.9-2.9Zm-18-30c2.2 0 4.1 1.4 4.7 3.2h-9.5c.7-1.9 2.6-3.2 4.8-3.2ZM4.5 35l2.8-23h2.2v3c0 1.1.9 2 2 2s2-.9 2-2v-3h10v3c0 1.1.9 2 2 2s2-.9 2-2v-3h2.2l2.8 23h-28Z" /></svg>
            {cartCount > 0 && <span className="cart-count">{cartCount}</span>}
          </Link>
        </div>
      </div>
    </header>
  );
}

export default Header;
